import { Component, Input, OnInit } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"
import { ResourceService } from "../../../services/resource.service"
import { Resource } from "../../../models/resource/resource"
import { LessonBuilderService } from "../../../services/lesson-builder.service"
import { AddOnViewService } from "../../../services/add-on-view.service"
import { Router } from "@angular/router"

@Component({
    selector: "app-share-link-google-class-modal",
    templateUrl: "./share-link-google-class-modal.component.html",
    styleUrls: ["./share-link-google-class-modal.component.scss"],
    standalone: false,
})
export class ShareLinkGoogleClassModalComponent implements OnInit {
    @Input() resource: Resource
    isAddonView: boolean

    constructor(
        public activeModal: ModalRef,
        public resourceService: ResourceService,
        public lessonBuilderService: LessonBuilderService,
        public addOnService: AddOnViewService,
        private router: Router
    ) {}

    ngOnInit() {
        this.isAddonView = this.addOnService.isAddonView
    }

    public openGoogleClassroom(isFocusViewLink: boolean) {
        this.resourceService.openGoogleClassroomSharableLink(
            isFocusViewLink ? this.resource.focusViewURL : this.resource.studentViewURL
        )
    }

    public openLessonBuilder() {
        this.lessonBuilderService.prefilledResource.next(this.resource)
        this.router.navigate(["/tools/lessonbuilder/new/"])
        this.activeModal.close()
    }
}
